<p-dialog
  header="Calculator"
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  appendTo="body"
  [style]="{ width: '60%' }"
>
  <!-- ── Helper panel ────────────────────────────────────────────── -->
  <p-card styleClass="helper-card mb-3 shadow-none surface-800">
    <ng-template pTemplate="title">
      <i class="pi pi-info-circle mr-2 text-primary-600"></i>
      How to use
    </ng-template>

    <ng-template pTemplate="subtitle">
      Enter an expression, hit <kbd>Enter</kbd> or click <i>Use&nbsp;result</i>.
    </ng-template>

    <ul class="helper-list m-0 pl-3 text-sm">
      <li><code>1000 - 350.75 / 2</code> → <em>824.625</em></li>
      <li><code>(25 + 5) * 1.07</code> → <em>32.1</em></li>
      <li><code>max(50,&nbsp;75)</code> → <em>75</em></li>
    </ul>
  </p-card>

  <div class="p-inputgroup">
    <input
      pInputText
      [(ngModel)]="expr"
      (ngModelChange)="update()"
      placeholder="Type 5*12 - 7%"
    />
    <p-inputgroup-addon>=</p-inputgroup-addon>
    <input pInputText [value]="result" disabled />
  </div>

  <ng-template pTemplate="footer">
    <p-button
      label="Use result"
      icon="pi pi-check"
      (click)="apply()"
      [disabled]="hasError"
    />
    <p-button
      label="Close"
      icon="pi pi-times"
      class="p-button-text"
      (click)="close()"
    />
  </ng-template>
</p-dialog>
